import { giphyRed } from '@giphy/colors'
import { ReactNode } from 'react'
import { IconButton, TextInput } from 'ui'
import { ArtboardTextLayerProps } from '../../../../artboard-gl/types'
import { UGELayer } from '../../../types'
import { Collapse } from './style'

type Props = {
    children?: ReactNode
    className?: string
    layer: UGELayer
    open?: boolean
    onOpen?: (layerId: string) => void
    onRemove?: (layerId: string) => void
    onTextChange?: (layerId: string, text: string) => void
}

const UGECaptionsEditorCaption = ({
    children,
    className,
    layer,
    open = false,
    onOpen: onOpenProp,
    onRemove: onRemoveProp,
    onTextChange: onTextChangeProp,
}: Props) => {
    const props = layer.props as ArtboardTextLayerProps

    function onFocus() {
        onOpenProp?.(layer.id)
    }

    function onOpen(isOpen: boolean) {
        if (isOpen) {
            onOpenProp?.(layer.id)
        }
    }

    function onRemove() {
        onRemoveProp?.(layer.id)
    }

    function onTextChange(text: string) {
        onTextChangeProp?.(layer.id, text)
    }

    return (
        <Collapse
            className={className}
            label={
                <TextInput
                    autoFocus={open}
                    multiline
                    size="medium"
                    value={props.text}
                    onChange={onTextChange}
                    onFocus={onFocus}
                >
                    <IconButton color={giphyRed} icon="trash" inverted size="medium" onClick={onRemove} />
                </TextInput>
            }
            open={open}
            size="medium"
            onChange={onOpen}
        >
            {children}
        </Collapse>
    )
}

export default UGECaptionsEditorCaption
